import React, { useState } from 'react';
import { ButtonChip, Link, Text } from 'pcln-design-system';
import { Globe } from 'pcln-icons';
const handleClick = ({
  setIsOpened,
  isOpened
}) => {
  return function (event) {
    event.preventDefault();
    event.stopPropagation();
    setIsOpened(!isOpened);
  };
};
export const CitationsSources = props => {
  const [isOpened, setIsOpened] = useState(false);
  const {
    webSearchResult
  } = props;
  const numberOfCitations = webSearchResult.length;
  const chipProps = {
    fontWeight: 'bold',
    label: 'Sources',
    facet: `(${numberOfCitations})`,
    Icon: Globe,
    expanded: isOpened,
    showActionIcon: true
  };
  return React.createElement(React.Fragment, null, React.createElement(ButtonChip, Object.assign({}, chipProps, {
    size: 'sm',
    my: 1,
    onClick: handleClick({
      isOpened,
      setIsOpened
    })
  })), isOpened && React.createElement(React.Fragment, null, webSearchResult.map((result, index) => {
    const url = new URL(result.url);
    const host = url.host;
    return React.createElement(React.Fragment, {
      key: `Web-search-res-${index}`
    }, React.createElement(Text, {
      fontSize: 0
    }, React.createElement(Text.span, null, result.citationNumber, ". "), React.createElement(Link, {
      href: result.url,
      target: '_blank'
    }, result.webPageName), React.createElement(Text.span, {
      ml: 1,
      color: 'text.light'
    }, host)));
  })));
};
CitationsSources.displayName = 'CitationsSources';